import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing * 8}px;
  img {
    max-width: 400px;
    height: auto;
  }
  > div {
    > h1, p {
      margin: 0;
    }
    > h1 {
      color: ${({ theme }) => theme.colors.secondary[900]};
      margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    }
    > p {
      color: ${({ theme }) => theme.colors.gray[400]};
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 ${({ theme }) => theme.spacing * 4}px;
    img {
      width: 200px;
    }
  }
`;
